import { render, staticRenderFns } from "./IconSvgNews.vue?vue&type=template&id=27fee90b&scoped=true&"
import script from "./IconSvgNews.vue?vue&type=script&lang=js&"
export * from "./IconSvgNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fee90b",
  null
  
)

export default component.exports